import axios from 'axios'
import { Base64 } from 'js-base64';
import {ElMessageBox} from 'element-plus'
import { 
    isTokenExpired, 
    isRefreshTokenExpired, 
    shouldRefreshToken, 
    refreshToken,
    getToken,
    clearAllStorage
} from '@/utils/tokenUtils'

let instance  = axios.create({
    responseType:'json',
    headers:{'content-Type':'application/json'}
})

// 是否正在刷新token的标志
let isRefreshing = false;
// 存储待重试的请求队列
let requestsQueue = [];

function baseFun(){
    const token = getToken();
    return 'Bearer '+token
}

/**
 * 跳转到登录页
 */
function redirectToLogin(message = '登录已过期，请重新登录') {
    ElMessageBox.alert(message, '提示', {
        confirmButtonText: '确定',
        type: 'warning'
    }).then(() => {
        clearAllStorage();
        window.location.href = '/';
    }).catch(() => {
        clearAllStorage();
        window.location.href = '/';
    });
}

// 请求拦截器
instance.interceptors.request.use(
    async config => {
        // 排除登录和刷新token的请求
        if (config.url && (config.url.includes('/oauth2/token') || config.url.includes('/oauth2/refresh'))) {
            return config;
        }
        
        let token = getToken();
        
        if (token) {
            // 检查token是否已过期
            if (isTokenExpired()) {
                console.log('Token已过期，尝试刷新');
                
                // 如果正在刷新，将请求加入队列
                if (isRefreshing) {
                    return new Promise((resolve) => {
                        requestsQueue.push(() => {
                            config.headers.Authorization = baseFun();
                            config.headers.sntoken = baseFun();
                            resolve(config);
                        });
                    });
                }
                
                isRefreshing = true;
                
                // 尝试刷新token
                const refreshed = await refreshToken();
                isRefreshing = false;
                
                if (refreshed) {
                    // 刷新成功，重试队列中的请求
                    requestsQueue.forEach(callback => callback());
                    requestsQueue = [];
                    
                    // 更新当前请求的token
                    config.headers.Authorization = baseFun();
                    config.headers.sntoken = baseFun();
                } else {
                    // 刷新失败，跳转登录
                    redirectToLogin();
                    return Promise.reject(new Error('Token已过期'));
                }
            } 
            // 检查token是否即将过期（小于3天）
            else if (shouldRefreshToken() && !isRefreshing) {
                console.log('Token即将过期，后台刷新');
                isRefreshing = true;
                
                // 后台刷新token，不阻塞当前请求
                refreshToken().then(refreshed => {
                    isRefreshing = false;
                    if (refreshed) {
                        console.log('后台刷新token成功');
                    }
                }).catch(() => {
                    isRefreshing = false;
                });
            }
            
            config.headers.Authorization = baseFun();
            config.headers.sntoken = baseFun();
        }
        
        return config;
    },
    err => {
        return Promise.reject(err);
    }
);

// 响应拦截器
instance.interceptors.response.use(
    response => {
        if (response.data.code === 401) {
            // Token验证失败，尝试刷新
            ElMessageBox.alert(response.data.msg,'认证失败',{
                confirmButtonText:'确定',
                type:'error'
            }).then(res=>{
                localStorage.clear()
                window.location.href='/'
            })
        } else if (response.data.code === 200) {
            // 正常进行 
        } else if (response.data.status != 200) {
            if (response.data.msg != null && response.data.msg.trim() != '') {
                ElMessageBox.alert(response.data.msg, '操作失败', {
                    confirmButtonText: '确定',
                    type: 'error'
                }).then(res => {
                    return;
                });
            }
        }
        return response;
    },
    async err => {
        if (err.response) {
            let errs = err.response.status;
            
            if (errs === 401) {
                // 401错误，尝试刷新token
                const originalRequest = err.config;
                
                // 避免刷新token接口本身401时无限循环
                if (originalRequest.url && originalRequest.url.includes('/oauth2/refresh')) {
                    redirectToLogin('登录已过期，请重新登录');
                    return Promise.reject(err);
                }
                
                // 如果正在刷新，将请求加入队列
                if (isRefreshing) {
                    return new Promise((resolve) => {
                        requestsQueue.push(() => {
                            originalRequest.headers.Authorization = baseFun();
                            originalRequest.headers.sntoken = baseFun();
                            resolve(axios(originalRequest));
                        });
                    });
                }
                
                // 检查refresh token是否过期
                if (isRefreshTokenExpired()) {
                    redirectToLogin('登录已过期，请重新登录');
                    return Promise.reject(err);
                }
                
                isRefreshing = true;
                
                // 尝试刷新token
                const refreshed = await refreshToken();
                isRefreshing = false;
                
                if (refreshed) {
                    // 刷新成功，重试所有队列中的请求
                    requestsQueue.forEach(callback => callback());
                    requestsQueue = [];
                    
                    // 重试当前请求
                    originalRequest.headers.Authorization = baseFun();
                    originalRequest.headers.sntoken = baseFun();
                    return axios(originalRequest);
                } else {
                    // 刷新失败，跳转登录
                    redirectToLogin('登录已过期，请重新登录');
                    return Promise.reject(err);
                }
            }
        }
        return Promise.reject(err.response ? err.response.data : err);
    }
);

export default instance




